import type { ErrorCode } from '@knockonwood/arcade-card-shared';

/**
 * Error thrown by the SDK for any non-2xx API response. Games switch on
 * `.code` — most importantly `INSUFFICIENT_FUNDS` → show a reload prompt.
 */
export class ArcadeCardError extends Error {
  readonly code: ErrorCode | 'NETWORK' | 'NOT_INITIALIZED';
  readonly status: number;

  constructor(code: ArcadeCardError['code'], message: string, status = 0) {
    super(message);
    this.name = 'ArcadeCardError';
    this.code = code;
    this.status = status;
  }
}
